<template>
  <el-dialog title="确认终止" :visible.sync="visible" width="30%">
    <p>请确认终止合同并填写原因</p>
    <el-form :model="data" :rules="rules" ref="endForm" label-width="0">
        <el-form-item label="" prop="endReason">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="500" show-word-limit v-model="data.endReason" placeholder="请输入500字以内" clearable />
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changeStatus } from "@/api/crm/contract";

export default {
  name: "EndDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      isBatch: false,
      rules: {
        endReason: [
          {required: true, message: '请输入终止原因', trigger: 'blur'}
        ]
      },
      data: {
        contractId: null,
        operateType: 2,
        endReason: ''
      }
    };
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("endForm");
      }
    }
  },
  methods: {
    options (id) {
      if (!id) {
        this.msgError("当前合同id异常")
        return
      }
      this.data.contractId = id
      this.visible = true
    },
    confirm () {
      this.$refs['endForm'].validate((valid) => {
        if (valid) {
            const loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading'
            });
            changeStatus(this.data).then(response => {
                this.$emit('success')
                this.visible = false
                loading.close();
                this.msgSuccess("合同终止成功");
            }).catch(error => {
                loading.close()
            })
        }
      });
    }
  }
};
</script>
